const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import EditChecker from '../../components/EditChecker/EditChecker';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";
// NOTE: referencing styles directly from stub folder so there's a single source of truth
require("../stubs/asnWizard/asnWizard.less");
import PackingTab from './PackingTab/PackingTab';
//import ContentsTab from './ContentsTab/ContentsTab';
import ServicesTab from './ServicesTab/ServicesTab';
import ShippingTab from './ShippingTab/ShippingTab';
import ReviewTab from './ReviewTab/ReviewTab';
import LocationTab from "./LocationTab.js";
import LocationInfoForCurrentAsn from "./businessLogic/LocationInfoForCurrentAsn";
import ProductItemStore from "../../stores/ProductItemStore";
import AsnStore from "../../stores/AsnStore";
import SaveAsn from './SaveAsn';
import addressValidationFactory from '../common/AddressValidation.js';
import asnQuoteSnapshotWatcherFactory from "./businessLogic/asnQuoteSnapshotWatcherFactory";
import shippingQuotesInvalidatorFactory from "./businessLogic/shippingQuotesInvalidatorFactory";
import quotesInvalidationFactory from "./common/quotesInvalidationFactory/quotesInvalidationFactory";
import asnInitialSnapshotFactory from "./businessLogic/asnInitialSnapshotFactory";
import {isBlank} from '../../utilities/general';
import {handleQueryParamTraversalToWizardTab} from '../../utilities/jumpToWizardLogic';




// Live form from jsp
run("#create-asn-form", ()=>{
  const el = $("#create-asn-form");
  attachWizard(el);
  setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-asn-form");
  EditChecker.bindChangeListener("span.select2");
  EditChecker.bindCancelButton("#asn-cancel-btn");

  $(".product-sku-input-outer input").on("change", function(e){
    EditChecker.setPageDirty();
  });
}

function attachWizard(el){
  const destTab = el.find('.destination-tab');

  const addressValidationModalEl = $("#add-validation-model");
  const asnId = el.data("asn-id");
  const addressValidation = addressValidationFactory(addressValidationModalEl, el, {
    isAlreadyValid: !!asnId
  });
  const quotesInvalidation = quotesInvalidationFactory();

  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },
    // onkeyup: false,
    // onfocusout: false
  });

  $.validator.addMethod('skuMustMatchProduct', function (val, element, param) {
    return ProductItemStore.doesSkuExist(val);
  }, "The sku must match an actual product's sku.");

  $.validator.addClassRules("sku-must-match-product", {skuMustMatchProduct: true});

  validator.settings.ignore = ":disabled,:hidden,.tt-hint";

  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 937,
    mobileWidthNavStep: 550,
    customRules: {
      ".packing-tab-asn-details-main-error-message": {
        errorMessageSelector: ".packing-tab-asn-details-main-error-message",
        isValid: function(){
          return packingTab.isValid();
        }
      },
      ".shipping-tab-radio-btn-main-error-message": {
        errorMessageSelector: ".shipping-tab-radio-btn-main-error-message",
        isValid: function(){
          return shippingTab.hasShippingPartnerSelected();
        }
      },
      ".shipping-tab-request-quote-not-clicked-error-message": {
        // leave errorMessageSelector Off and let given sub view handle hiding/showing it,
        // while allowing the wizard to still probe the given tab for any errors on next btn click.
        isValid: function(){
          // if we do not have a shipping partner ("No, I will handle Inbound shipping"),
          // then we don't care about this error.
          // if it is parcel, then we also don't care about this error.
          return !shippingTab.hasShippingPartner() || (shippingTab.isParcel() && !shippingTab.hasCasePackingPalletShipping())||
          (
            !shippingTab.isFetchingQuotes() &&
            (
              shippingTab.didRequestQuotes() ||
              shippingTab.hasSpecialQuote() ||
              shippingTab.hasSelectedQuote()
            )
          );
        }
      },
      ".shipping-tab-request-quote-no-selected-quote-error-message": {
        // leave errorMessageSelector Off and let given sub view handle hiding/showing it,
        // while allowing the wizard to still probe the given tab for any errors on next btn click.
        isValid: function(){
          // if we do not have a shipping partner ("No, I will handle Inbound shipping"),
          // then we don't care about this error.
          // if it is parcel, then we also don't care about this error.
          return !shippingTab.hasShippingPartner() || (shippingTab.isParcel() && !shippingTab.hasCasePackingPalletShipping()) ||
          (
            !shippingTab.isFetchingQuotes() &&
            (
              shippingTab.hasSpecialQuote() ||
              shippingTab.hasSelectedQuote()
            )
          );
        }
      },
      ".shipping-tab-pickup-time-range-error-message": {
        isValid: function(){
          return !shippingTab.isGTL() || shippingTab.isPickupTimeRangeValid();
        }
      }
    },

    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
      // return true;
     // Any time we go traverse backwards, just let us
      if(direction === "BACKWARDS"){
        return true;
      }
      
      if(!targetForm.hasClass('shipping-tab') && !targetForm.nextAll('.shipping-tab').length){
        AsnStore.updateObjectAndEmit(getCurrentAsnId(), {attemptedTraversalPassedShippingTab: true});
          if(shippingTab.hasShippingPartnerSelected()){
            if(shippingTab.hasShippingPartner() && shippingTab.isInternational()){
              return false; 
            }

            if (!shippingTab.isCarrierNameValid()) {
              runValidation();
              return false;
            }
          }else{
            return false; 
          }
      }

      if(currentForm.filter(".location-tab").length){
        const completeQuotesModalFunc = _.partial(handleDetermineInvalidateQuotesModal, _, done);
        const completeAddressModalFunc = _.partial(handleDetermineAddressModal, _, completeQuotesModalFunc);
        const completeValidatingFormFunc = _.partial(areInputsValid, completeAddressModalFunc);
        completeValidatingFormFunc();
      }
      else if(currentForm.filter(".packing-tab").length){
        const completeQuotesModalFunc = _.partial(handleDetermineInvalidateQuotesModal, _, done);
        const completeValidatingFormFunc = _.partial(areInputsValid, completeQuotesModalFunc);
        completeValidatingFormFunc();
      }
      else{
        areInputsValid(done);
      }

      function isCarrierNameValid(){
        return shippingTab.isCarrierNameValid()
      }

      function runValidation() {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
        if (notValid) {
          quickWizard.goToFirstIncompleteForm();
        }
      }

      function areInputsValid(cb){
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, {displayErrors: true});
        if(notValid){
          quickWizard.goToFirstIncompleteForm();

          cb(false);
        } else{
          cb(true);
        }
      }

      function handleDetermineAddressModal(canContinueToNextForm, cb){
        // if canContinueToNextForm is true at this point,
        // the flow to continue to the next form is
        // has not stopped, so we should determine
        // whether or not to show the address validation modal
        if(canContinueToNextForm){
          addressValidation.determineAddressValidity(cb);
        } else {
          cb(canContinueToNextForm);
        }
      }

      function handleDetermineInvalidateQuotesModal(canContinueToNextForm, cb){
        console.log("determining whether or not to show quotes invalidated modal...");
        // if canContinueToNextForm is true at this point,
        // the flow to continue to the next form is
        // has not stopped, so we should determine
        // whether or not to show the quote invalidation modal
        if(canContinueToNextForm){
          quotesInvalidation.determineQuoteInvalidPrompt(cb);
        }
        else{
          cb(canContinueToNextForm);
        }
      }


      return done;
    },

    didNavigateToForm: function({currentForm}){
      if(currentForm.filter(".review-tab").length){
        reviewTab.didNavigateToForm();
      }

      shippingTab.setIsOnTab(!!currentForm.filter(".shipping-tab").length);


    }
  });

   quickWizard.init();

  // The Class below is migration from
  // the incorrectly architected LocationTab Class,
  // in favor of the better Evented Architecture
  const locationInfoForCurrentAsn = new LocationInfoForCurrentAsn(quickWizard);
  locationInfoForCurrentAsn.init();

  const locationTab = new LocationTab(quickWizard);
  locationTab.init();

  const packingTab = new PackingTab(quickWizard);
  packingTab.init();

  //const contentsTab = new ContentsTab(quickWizard);
  //contentsTab.init();

  const savAsn = new SaveAsn(quickWizard, {
    canSave: function(){
      const currentForm = quickWizard.getActiveTargetForm();
      let isValid = true;

      if(currentForm.filter(".location-tab").length){
        isValid = areInputsValidForForm(currentForm);
      }


      return isValid;
    }
  });
  savAsn.init();

  const servicesTab = new ServicesTab(quickWizard);
  servicesTab.init();

  const shippingTab = new ShippingTab(quickWizard);
  shippingTab.init();

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();

  const asnQuoteSnapshotWatcher = asnQuoteSnapshotWatcherFactory();
  const shippingQuotesInvalidator = shippingQuotesInvalidatorFactory();

  const asnInitialSnapshotter = asnInitialSnapshotFactory();

  asnInitialSnapshotter.createSnapshots();
  asnQuoteSnapshotWatcher.generateInitialSnapshotsOnLoad();

  validateOnAllSelectChanges();

  // helper functions
  function getCurrentAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getCurrentAsnId(){
    return getCurrentAsn().id;
  }

  function areInputsValidForForm(form){
    let inputs = quickWizard.findValidatableElementsForScope(form);
    let valid = quickWizard.areInputsValid(inputs, {displayErrors: true});
    // For now, this function is only applicable to saving an
    // Asn while on location tab to facility if all inputs
    // for that given tab are valid, so we don't need
    // to traverse anywhere.
    // if(notValid){
    //   quickWizard.goToFirstIncompleteForm();
    // }
    return valid;
  }

  handleQueryParamTraversalToWizardTab(quickWizard);
}



// WEBPACK FOOTER //
// ./src/pages/asns/asnWizard.js